import application from 'application/application';


application.service('blocked', ['$http', 'helper', 'API', function($http, helper, API) {

	let blockedUser = localStorage.getItem('__authenticationUserBlocked__');
	let currentStatus = false;

	this.updateStatus = () => {

		$http({
			...helper.http(API.contracts, 'GET'),
			params: {
				...helper.httpFields(['*']),
				registrosPorPagina: -1
			}
		}).then(response => {
			let contract = response.data.itens;

			const blockedStatus = [-3, -6];
			const validUser = contract.filter(element =>
				element.idSituacaoContrato === -1);

			contract.forEach(element => {

				if (element.idSituacaoContrato === -1 || validUser.length) {
					currentStatus = false;
				}
				else {
					blockedStatus.forEach(blocked => {
						if (element.idSituacaoContrato == blocked) {
							currentStatus = true;
						};
					});
				}

			});
		})
			.finally(() => {
				if (currentStatus != blockedUser)
					localStorage.setItem('__authenticationUserBlocked__', currentStatus);
			});
	};

}]);
